import React from 'react';
import BasePage from '@/components/BasePage';
import BaseLayout from '@/components/layouts/BaseLayout';
import { Container } from 'reactstrap';
import Booking from '@/components/Booking';
// Translation Higher Order Component
import { translate } from 'react-switch-lang';

const Narcotest = ({ t }) => {
	return (
		<React.Fragment>
			<BaseLayout
				className='cover'
				title='Narco Test'
				description={`${t('narcotest.text1')}`}
				keywords={`COVID-19 ${t('SEO.keywords_common')} ${t('SEO.keywords_narcotest')}`}
				canonical='/narco-test'
			>
				{/* Base Page - Shared component with Container */}
				<BasePage id='narcotest-page' className='narcotest-page'>
					<Container>
						<article>
							<h1 className='page_text font-weight-bold'>{t('navbar.narcotest')}</h1>
							<h2 className='page_subtext text-uppercase'>{t('coronatest.title')}</h2>
							<hr className='vaccination-page_hr' />
							<p>{t('narcotest.text1')}</p>
							<p>{t('narcotest.text2')}</p>
							<br />
							<h2 className='page_subtext text-uppercase'>{t('narcotest.title')}</h2>
							<p>{t('narcotest.text3')}</p>
							<p>{t('narcotest.text4')}</p>
							<ul>
								<li>{t('narcotest.text5')}</li>
								<li>{t('narcotest.text6')}</li>
								<li>{t('narcotest.text7')}</li>
							</ul>
							<p>{t('narcotest.text8')}</p>
							<p>{t('narcotest.text9')}</p>
							<br />
							<h2 className='page_subtext text-uppercase'>{t('narcotest.title2')}</h2>
							<p> {t('narcotest.text10')}</p>
							<h3 className='page_subtext text-uppercase'>{t('coronatest.price')}</h3>
							<p>690 DKK {t('narcotest.text11')}</p>
							<p>{t('coronatest.text10')}</p>
							<Booking />
						</article>
					</Container>
				</BasePage>
			</BaseLayout>
		</React.Fragment>
	);
};

export default translate(Narcotest);
